import endpoints from './endpoints';

describe('endpoints', () => {
  test('it should have proper object properties', () => {
    expect(endpoints).toHaveProperty('get');
    expect(endpoints).toHaveProperty('put');
    expect(endpoints.get).toHaveProperty('hierarchySummary');
    expect(endpoints.get).toHaveProperty('context');
    expect(endpoints.put).toHaveProperty('context');
  });
});
